/*
 * Authors: mariushirjanu
 * Created: 04/07/2022
 */
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../shared/services/formatting.service';
import { IDialogButton } from '../../../shared/message/ga-message.service';
import { GaValidateService } from '../../../shared/formly/ga-validate.service';
import { IOrderFeesConfirmPayment, IOrderFeesHeader, OrderFeesDataService } from './order-fees-data.service';
import { TranslationService } from '../../../shared/translation/translation.service';

@Component({
  selector: 'confirm-proforma-dialog',
  template: `
    <default-dialog [title]="title" [buttons]="buttons">
      <formly [form]="form" [fields]="fields" [model]="model"></formly>
    </default-dialog>
  `
})
export class ConfirmPaymentDialogComponent implements OnInit {
  @Input() public title:string;
  @Input() public paymentTotal:string;
  @Input() public currency:string;
  @Input() public invoiceId:number;
  @Output() public onSaved:EventEmitter<IOrderFeesHeader> = new EventEmitter<IOrderFeesHeader>();

  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public model:IOrderFeesConfirmPayment;
  public buttons:IDialogButton[];

  constructor(
    private formattingService:FormattingService,
    private formlyService:GaFormlyService,
    private orderFeesDataService:OrderFeesDataService,
    private translationService:TranslationService,
    private validateService:GaValidateService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.start();
  }

  private start():void {
    this.buttons = [ {
      label: this.title,
      className: 'btn btn-success',
      onClick: () => this.doConfirm()
    }, {
      label: 'GA.BUTTONS.CANCEL',
      className: 'btn btn-danger'
    } ];

    this.fields = this.createFields();
    this.model = {};
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const fields:IExtraFieldConfigurationObject[] = [];

    fields.push(
      this.formlyService.aCheckbox('confirmed', this.translationService.instant('INVOICE.ORDERFEES.CHECKBOXCONFIRMPAYMENT.LABEL', {amount: `<span class="bold">${this.formattingService.formatAmount(this.paymentTotal, this.currency)}</span>`}))
        .isRequired()
        .withoutWrapper()
        .withWrapperClass('group')
        .withoutEditable()
        .withValidationMessage('required', 'INVOICE.ORDERFEES.CHECKBOXCONFIRMVALIDATION.TEXT')
        .build(),

      this.formlyService.aDateInput('paymentDate', 'GA.GENERAL.DATE')
        .isRequired()
        .withLabelClass('col-md-3')
        .withValueClass('col-md-3')
        .withoutEditable()
        .withFormat(this.formattingService.formatDate)
        .build(),

      this.formlyService.aTextarea('paymentComment', 'GA.GENERAL.COMMENTS')
        .withLabelClass('col-md-12')
        .withValueClass('col-md-12')
        .withInfo('INVOICE.ORDERFEES.CONFIRM_PAYMENT_COMMENT.INFO')
        .showInfo()
        .withoutEditable()
        .build()
    );

    return fields;
  }

  private doConfirm():void {
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.orderFeesDataService.confirmPayment(this.invoiceId, this.model)
          .then((invoiceHeader:IOrderFeesHeader) => {
            this.onSaved.emit(invoiceHeader);
          });
      });
  }
}